export default [
  { name: 'ES', code: 'es' },
  { name: 'EN', code: 'en' },
  { name: 'PT', code: 'pt' }
]
